import { SalesOrderAccounting } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1410. 受注案件管理会計編集
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_accountings/:sales_order_accounting_id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  sales_order_accounting_id: number;
  monthly_amount?: number;
  spot_amount?: number;
};
const updateSalesOrderAccounting = (props: Props): Promise<SalesOrderAccounting> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_accountings/${props.sales_order_accounting_id}`,
    props
  );
};
export const useUpdateSalesOrderAccounting = () => {
  return useMutation({
    mutationFn: updateSalesOrderAccounting,
  });
};
